module.exports = __webpack_public_path__ + "static/img/homenew3.016cb378.png";